/**
 * Shared presentation helpers for assignment and group tables.
 */
export function useAssignmentPresentation() {
  function formattedHours(value) {
    const normalizedValue = String(value ?? "").trim();
    return normalizedValue !== "" && normalizedValue !== "-" ? normalizedValue : "-";
  }

  function subjectTypeClasses(subjectTypeId) {
    const normalizedTypeId = Number.parseInt(String(subjectTypeId ?? "0"), 10) || 0;
    return normalizedTypeId > 0 ? ["type-color", `type-color--${normalizedTypeId}`] : [];
  }

  function subjectTypeClass(subjectTypeId) {
    return subjectTypeClasses(subjectTypeId).join(" ");
  }

  return {
    formattedHours,
    subjectTypeClasses,
    subjectTypeClass,
  };
}
